export enum JudgmentCancellationInformationTypesEnum {
  CANCELLATION = 'Отмена решения',
  WITHOUT_CHANGES = 'Без изменений',
  PARTIAL_CANCELLATION = 'Частичная отмена',
}
